import { useEffect, useState } from "react";
import { getSettings } from "@/lib/api";
import { DEFAULT_TEMPLATES } from "@/lib/format";

// Shared hook to fetch message templates from server settings.
// Falls back to defaults if settings call fails.
export const useMessageTemplates = () => {
  const [templates, setTemplates] = useState(DEFAULT_TEMPLATES);
  useEffect(() => {
    getSettings()
      .then((s) => {
        if (s?.message_templates) setTemplates({ ...DEFAULT_TEMPLATES, ...s.message_templates });
      })
      .catch(() => {});
  }, []);
  return templates;
};
